import {
  fillZeroToAccountType,
  fillZeroToExpenditureNature,
  fillZeroToExpenditurePurpose,
  fillZeroToRevenueNature,
} from './code-formatter';

export const accountTypeNameWithCode = (code: number, name: string) => {
  return `${fillZeroToAccountType(code)} ${name}`;
};

export const expenditurePurposeNameWithCode = ({
  code,
  name,
  level,
  isMajorMatter,
  withColonSeparator,
}: {
  code: number | string;
  name: string;
  level: number;
  isMajorMatter?: boolean;
  withColonSeparator?: boolean;
}) => {
  const separator = withColonSeparator ? ':' : '';
  return `${fillZeroToExpenditurePurpose({
    value: code,
    isLevel2: level === 2,
    isMajorMatter: !!isMajorMatter,
  })}${separator} ${name}`;
};

export const expenditureNatureNameWithCode = ({
  code,
  name,
  level,
  withColonSeparator,
}: {
  code: number;
  name: string;
  level?: number;
  withColonSeparator?: boolean;
}) => {
  const separator = withColonSeparator ? ':' : '';
  return `${fillZeroToExpenditureNature(code, level === 2)}${separator} ${name}`;
};

export const revenueNatureNameWithCode = (
  code: number,
  level: number,
  name: string,
) => {
  return `${fillZeroToRevenueNature(code, level === 4)} ${name}`;
};
